import React, { useEffect } from "react"
import { AutocompleteSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useCsv } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { isEmpty } from "@ui-seeker/utils"

const weekDaysOptions = [
	{ label: "Monday", value: 0 },
	{ label: "Tuesday", value: 1 },
	{ label: "Wednesday", value: 2 },
	{ label: "Thursday", value: 3 },
	{ label: "Friday", value: 4 },
	{ label: "Saturday", value: 5 },
	{ label: "Sunday", value: 6 },
]

export default function CheckinWeekdayField() {

	const {
		checkinWeekdayFilter,
		setCheckinWeekdayFilterInfo,
		error
	} = useReportFormInfo(reportFormData.peek().checkinWeekdayFilter, "checkinWeekdayFilter", object({ checkinWeekdayFilter: array().nullable() }))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setCheckinWeekdayFilterInfo([], false)
		}
	}, [useCsv.value])

	return <AutocompleteSeeker
		multiple
		label="Weekday filter"
		placeholder="Select days of the week"
		options={weekDaysOptions}
		value={checkinWeekdayFilter || []}
		onChange={e => setCheckinWeekdayFilterInfo(e.target.value)}
		error={error}
	/>
}